<script lang="ts">
    import EmployeeWidget from "$lib/partials/EmployeeWidget.svelte";
    import {Button, Fileupload, Input, Modal, Select, Spinner} from "flowbite-svelte";
    import {DownloadSolid, TrashBinSolid, UploadSolid} from "flowbite-svelte-icons";
    import {storeEmployeeImage} from "$lib/calls/files";
    import {deleteEmployeeImage} from "$lib/calls/employee";

    export let employee;

    let uploading = false;
    let photoUploadModal = false;
    let imageModal = false;
    let selectedImage = null;


    let photo: Blob;
    let photoTag = 'sedcard'
    let photoTags = [
        {name: 'Sedcard', value: 'sedcard'},
        {name: 'Mitarbeiterausweis', value: 'employee-id'},
        {name: 'Sonstiges', value: 'other'}
    ]


    const photoLoader = (e) => {
        photo = e.target.files[0]
    }

    let submitPhoto = () => {
        uploading = true
        employee = storeEmployeeImage(photo, photoTag, employee.uuid).then(() => {
            uploading = false
            photoUploadModal = false
            console.log(photoUploadModal)
        })
    }
    const setImage = (image) => {
        selectedImage = image
        imageModal = true;
    }
    const deleteImage = () => {
        imageModal = false;
        deleteEmployeeImage(employee.uuid, selectedImage).then((e) => {
            employee = e;
        })
    }

</script>

<EmployeeWidget headline="Fotos">
    <svelte:fragment slot="cta">
        <Button
                on:click={() => photoUploadModal = true}
                class="py-1"
                size="xs">
            <UploadSolid class="w-3 h-3 mr-2"/>
            <span>Foto hinzufügen</span>
        </Button>

    </svelte:fragment>
    <svelte:fragment slot="left">
        {#if employee.images?.length}
            {#each employee.images as image}
                <div on:click={() => setImage(image)} on:keydown={() => setImage(image)}
                     class="relative w-1/2 rounded border cursor-pointer hover:border-primary-400">
                    <img class="w-full" src={image.location} alt={image.location}>
                </div>
            {/each}
        {/if}
    </svelte:fragment>
</EmployeeWidget>
<Modal
        title="Foto hinzufügen"
        bind:open={photoUploadModal}>
    <form class="space-y-5">
        <Fileupload on:change={photoLoader} accept="image/*"/>

        <Select label="Typ" bind:value={photoTag} items={photoTags}/>
    </form>
    <svelte:fragment slot="footer">
        {#if !uploading}
            <Button on:click={submitPhoto}>
                <Icon
                        name="upload-solid"
                        class="w-3 h-3 mr-2"/>
                Hochladen
            </Button>
            <Button
                    on:click={() => photoUploadModal = false}
                    color="alternative">
                Abbrechen
            </Button>
        {:else}
            <Spinner/>
        {/if}
    </svelte:fragment>
</Modal>
<Modal title={selectedImage?.imageTag?.toUpperCase()} bind:open={imageModal}>
    <img class="w-full" src={selectedImage.location} alt={selectedImage.location}>
    <div class="flex justify-between">

        <Button href={selectedImage.location}>
            <DownloadSolid class="w-3 h-3 mr-2"/>
            <span>Download</span>
        </Button>
        <Button on:click={() => deleteImage()} color="red">
            <TrashBinSolid class="w-3 h-3 mr-2"/>
            <span>Löschen</span>
        </Button>
    </div>
</Modal>